import isNil from 'lodash/isNil'

export function extractSlugFromPath (path: string): string {
  const yiPathRegexp = /yoga-international\/(en|es)\/[\w-]+\/(?<slug>[^/]+)(?:\/\d+\/\d+)?\/?$/i

  if (yiPathRegexp.test(path)) {
    const result = yiPathRegexp.exec(path)
    const slug = result?.groups?.slug
    if (isNil(slug)) {
      return ''
    }
    return slug
  }
  return path
}
